import { render, staticRenderFns } from "./value-modal.vue?vue&type=template&id=709e8323"
import script from "./value-modal.vue?vue&type=script&lang=js"
export * from "./value-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports